<div class="login-content">
  <img
    class="close-icon"
    src="./../../../../assets/icons/x.svg"
    alt=""
    (click)="onNoClick()"
  />

  <div class="login-content-logo">
    <img src="../../../../assets/logo/Logo.svg" alt="" />
  </div>
  <p class="title">Check Your Email!</p>

  <p class="paragraph2">
    We've sent you an email to reset your password.
  </p>

  <button class="primary-btn" type="submit" (click)="onNoClick()">Great!</button>
</div>
